import { status } from '../../config.ts'

import { wait } from '@/__mocks__/util/async.ts'
import {
  creditLimit,
  promotionsByClient
} from '@/__mocks__/modules/calculator/data.ts'

export default [
  {
    method: 'GET',
    path: '/clients/12345/credit-limit',
    reply: async () => {
      await wait()
      return [status.ok, creditLimit]
    }
  },
  {
    method: 'POST',
    path: '/promotions/by-client/12345',
    reply: async () => {
      await wait()
      return [status.ok, promotionsByClient]
    }
  }
]
